import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackAndTraceActionCreator } from '../redux/actions/DashboardActions';
import { deleteSavedUserReportRequestActionCreator } from '../../user/redux/actions/UserActions';
import {
  getDashboardProps,
  getPinnedReports,
  getSavedReports,
  getRecentReports,
} from '../redux/selectors/DashboardSelectors';
import DashboardReportTypes from '../redux/actions/types/DashboardReportTypes';
// eslint-disable-next-line import/no-named-as-default
import ReportItemContainer from './ReportItemContainer';
import DeleteModal from '../../common/components/DeleteModal';
import Button from '../../../core/modules/common/components/Button';
import themeStyles from '../../../materialUiTheme';
import config from '../../../core/config/configureSettings';

export const sections = [
  {
    key: DashboardReportTypes.PINNED,
    title: 'Favourite',
  },
  {
    key: DashboardReportTypes.RECENT,
    title: 'Recent',
  },
  {
    key: DashboardReportTypes.SAVED,
    title: 'Saved',
  },
];

const initialState = {
  showDeleteSavedReportModal: false,
  savedIdToBeDeleted: 0,
};

// eslint-disable-next-line react/prefer-stateless-function
export class DashboardMyReportsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  getAtatPagePath = (atatId) => {
    let type = '';

    if (atatId.length === 29) {
      type = 'receptacle';
    } else if (atatId.length === 20) {
      type = 'despatch';
    } else if (atatId.length <= 12 && atatId.length > 0) {
      type = 'consignment';
    } else {
      type = 'item';
    }

    return type && atatId ? `/en/${type}/${atatId}` : '';
  }

  updateAtatId = e =>
    this.props.trackAndTraceActionCreator(e.target.value);

  gotoAtatPage = () => {
    const { atatSystem } = config.applications;
    const host = atatSystem;
    const path = this.getAtatPagePath(this.props.dashboard.atatId);

    if (path) {
      window.open(host + path, '_blank');
      this.props.trackAndTraceActionCreator('');
    }
  }

  closeDeleteModal = () => {
    this.setState(initialState);
  };

  openDeleteModal = (savedIdToBeDeleted) => {
    this.setState({
      showDeleteSavedReportModal: true,
      savedIdToBeDeleted,
    });
  };

  deleteSavedReport = () => {
    this.props.deleteSavedUserReportRequestActionCreator(this.state.savedIdToBeDeleted);
    this.closeDeleteModal();
  }

  render() {
    return (
      <div className="dashboard-content">
        <div className="report-definitions">
          <section className="report-definitions__sections">
            <section className="section" id="trackAndTrace">
              <div className="section-title">
                <h5>Track and trace</h5>
              </div>
              <div className="dashboard-track-and-trace">
                <input
                  className="text-input input-search"
                  value={this.props.dashboard.atatId}
                  onChange={this.updateAtatId}
                  placeholder="Please enter a consignment, despatch, receptacle or item identifier"
                />
                <Button
                  style={themeStyles.blueButton}
                  onClick={this.gotoAtatPage}
                  text="app.button.search"
                />
              </div>
            </section>
            {sections.map(section =>
              this.props[section.key] && section.key === 'pinned' && (
                <section className="section" id={section.key} key={section.key}>
                  <div className="section-title">
                    <h5>{section.title}</h5>
                  </div>
                  <div className="reports">
                    {this.props[section.key]
                      .map((report, i) =>
                        (<ReportItemContainer
                          key={report.reportCode + i} // eslint-disable-line
                          type={section.key}
                          report={report}
                          openDeleteModal={this.openDeleteModal}
                        />))}
                  </div>
                </section>
              ))}
            {sections.map(section =>
              this.props[section.key] && this.props[section.key].length > 0 && section.key !== 'pinned' && (
              <section className="section" id={section.key} key={section.key}>
                <div className="section-title">
                  <h5>{section.title}</h5>
                </div>
                <div className="reports">
                  {this.props[section.key]
                    .map((report, i) =>
                      (<ReportItemContainer
                        key={report.reportCode + i} // eslint-disable-line
                        type={section.key}
                        report={report}
                        openDeleteModal={this.openDeleteModal}
                      />))}
                </div>
              </section>
              ))}
          </section>
        </div>
        {this.state.showDeleteSavedReportModal &&
          <DeleteModal
            headerFormattedMessageId="app.warning.delete.save.operator.selection"
            onCloseModal={this.closeDeleteModal}
            deleteSelection={this.deleteSavedReport}
          />}
      </div>
    );
  }
}

DashboardMyReportsContainer.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.shape),
  trackAndTraceActionCreator: PropTypes.func,
  deleteSavedUserReportRequestActionCreator: PropTypes.func,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  trackAndTraceActionCreator,
  deleteSavedUserReportRequestActionCreator,
}, dispatch);

const mapStateToProps = state => ({
  dashboard: getDashboardProps(state),
  pinned: getPinnedReports(state),
  saved: getSavedReports(state),
  recent: getRecentReports(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardMyReportsContainer);
